import { useQuery, useMutation } from 'react-query';

import { Appointments, CalendarUsers, UserResponse } from '@/features/availability/types';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

export type DTO = {
  appointmentId?: any;
  roomId?: string;
};

export const getRefundDetails = ({
  appointmentId,
  roomId,
}: DTO): Promise<{ refundAmount: number }> => {
  return axios.get(
    roomId
      ? `/parent/rooms/${roomId}/refund-details/${appointmentId}`
      : `/parent/refund-details/${appointmentId}`
  );
};

type UseOptions = {
  config?: MutationConfig<typeof getRefundDetails>;
};

export const useGetRefundDetails = ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getRefundDetails,
  });
};

type QueryFnType = typeof getRefundDetails;
export const useRefundDetailsQuery = ({ appointmentId }: DTO) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['refund-details'],
    queryFn: () => getRefundDetails({ appointmentId }),
  });
};
